import { c as _c } from "react/compiler-runtime";
import type { GiftProductApiDto } from '__generated__/api/unauth/types.gen';
import { GiftListItem } from '@/app/_components/DonationTemp/GiftListItem';
import { ROUTES } from '@/constants';
import { HorizontalSlider } from './HorizontalSlider';
import { SectionHeader } from './SectionHeader';
const PREVIEW_SLIDER_COUNT = 5;
export function GiftPreviewSection(t0) {
  const $ = _c(11);
  const {
    keyword,
    items,
    totalCount,
    isLoading
  } = t0;
  if (!isLoading && items.length < 1) {
    return null;
  }
  let t1;
  if ($[0] !== keyword) {
    t1 = ROUTES.SEARCH.withSearchParams({
      searchParams: {
        q: keyword || undefined,
        category: "gifts"
      }
    });
    $[0] = keyword;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1 || $[3] !== totalCount) {
    t2 = <SectionHeader title={"\uB2F5\uB840\uD488"} totalCount={totalCount} moreHref={t1} />;
    $[2] = t1;
    $[3] = totalCount;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== isLoading || $[6] !== items) {
    t3 = isLoading ? <HorizontalSlider className="mobile-tablet:pl-20">{Array.from({
        length: PREVIEW_SLIDER_COUNT
      }, _temp)}</HorizontalSlider> : <HorizontalSlider className="mobile-tablet:pl-20">{items.map(_temp2)}</HorizontalSlider>;
    $[5] = isLoading;
    $[6] = items;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = <section className="flex w-full flex-col">{t2}{t3}</section>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}
function _temp2(item) {
  return <div key={item.productNumber ?? item.productId} className="max-w-220 flex-[0_0_calc((100%-24px)/2.5)] mobile:min-w-160"><GiftListItem mainImageUrl={item.mainImageUrl} productName={item.productName} donationAmount={item.requiredDonationAmount} reviewRating={item.reviewRating} reviewCount={item.reviewCount} productNumber={item.slugId ?? item.productNumber} responsiveClassName={{
      productName: "min-h-[2lh]"
    }} /></div>;
}
function _temp(_, index) {
  return <div key={index} className="max-w-220 flex-[0_0_calc((100%-24px)/2.5)] mobile:min-w-160"><GiftListItem isLoading={true} /></div>;
}